import React from 'react';
import { Card, Accordion } from 'react-bootstrap';
import { DebounceInput } from "react-debounce-input";
import NumberToPersianWord from "number_to_persian_word";
import { NumToFa} from "../../Functions/TextTransform";



export default function Step5BTrackPleatedSheer({
 ContextAwareToggle,
 requiredStep,
 stepSelectedLabel,
 setDeps,
 setCart,
 t,
 step3,
 step31,
 step3ARod,
 step3ARod1,
 depSet,
 accordionActiveKey,
 step3A0,
 rodWidth,
 setRodWidth,
 setCartLoading,
 optionSelectChanged,
 selectChanged,
 pageLanguage,
 NextStep,
 step3ATrack
}) {
 
  
  return (
   <Card
   className={
     step3 === "true" &&
     step31 === "Track" &&
     step3ATrack !== "" ? ""
       : "noDisplay"
   }
 >
   <Card.Header
     className={
       [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
       !accordionActiveKey.startsWith("3")
         ? "hidden"
         : ""
     }
   >
     <ContextAwareToggle
       eventKey="3B"
       stepNum={t("4B")}
       stepTitle={t("pleated_step3BRod")}
       stepRef="3BRod"
       type="2"
       required={requiredStep["3BRod"]}
       stepSelected={
         stepSelectedLabel["3BRod"] === undefined ? "" : stepSelectedLabel["3BRod"]
       }
     />
   </Card.Header>
   <Accordion.Collapse eventKey="3B">
     <Card.Body>
       <div className="card_body">
         <div className="box100">
           <p className="step_selection_title">{t("pleated_step3BRod_title")}</p>
           <img
             src={
               step3A0 === "Moulding"
                 ? require("../../Images/drapery/grommet/rod_width_arc.svg").default
                 : require("../../Images/drapery/grommet/rod_width.svg").default
             }
             className="img-fluid frame_with_top"
             alt=""
           />
         </div>
         <div className="box100 Three_selection_container">
           <div className="box100">
             <div className="measure_input_container">
               <h1 className="measure_input_label">{t("Width-1")}</h1>
               <div className="measure_input_field_container">
                 <DebounceInput
                   debounceTimeout={1500}
                   autoComplete="off"
                   onKeyDown={(e) => {
                     if (
                       !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                       e.keyCode !== 8 &&
                       e.keyCode !== 46 &&
                       e.keyCode !== 37 &&
                       e.keyCode !== 39 &&
                       e.keyCode !== 13
                     ) {
                       e.preventDefault();
                     }
                   }}
                   className={
                     "measure_input" +
                     (rodWidth !== undefined && (rodWidth < 1 || rodWidth > 1000)
                       ? " measure_input_err"
                       : "")
                   }
                   type="text"
                   name="rodWidth"
                   value={NumToFa(`${rodWidth || ""}`, pageLanguage)}
                   onChange={(e) => {
                     setTimeout(() => {
                       let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                       newValue = isNaN(newValue) ? "" : newValue;
                       if (
                         newValue &&
                         newValue !== "" &&
                         parseInt(newValue) >= 1 &&
                         parseInt(newValue) <= 1000
                       ) {
                         setCartLoading(true);
                         setCart("RodWidth", parseInt(newValue));
                         setDeps("", "3BRod");
                         setRodWidth(parseInt(newValue));
                         optionSelectChanged(
                           "3BRod",
                           parseInt(newValue),
                           "cm",
                           "س\u200Cم",
                           pageLanguage
                         );
                       } else {
                         setCartLoading(true);
                         setCart("", "", "RodWidth");
                         setDeps("3BRod", "");
                         if (newValue === "" || isNaN(parseInt(newValue))) {
                           setRodWidth(undefined);
                           selectChanged(undefined, "3BRod");
                         } else {
                           setRodWidth(parseInt(newValue));
                           selectChanged("3BRod", undefined, t("Invalid Measurements"));
                         }
                       }
                     }, 300);
                   }}
                 />
                 <div className="measure_input_postfix">{t("cm_label")}</div>
               </div>
             </div>
           </div>
         </div>
         <NextStep currentStep="3BRod" eventKey="3C">
           {t("NEXT STEP")}
         </NextStep>
       </div>
     </Card.Body>
   </Accordion.Collapse>
 </Card>
  )
}
